import React from 'react';
import { styles } from './DescriptionList.css';

export type DescriptionListItem = {
  Name: string;
  Values: Array<string>;
};

export type DescriptionListProps = {
  listItems?: Array<DescriptionListItem>;
};

export const DescriptionList = ({ listItems }: DescriptionListProps): JSX.Element => {
  return (
    <dl className={styles.root}>
      {listItems.map((item: DescriptionListItem) =>
        item.Values.length
          ? !item.Values.includes('False') && (
              <div className={styles.listItem} key={item.Name}>
                <dt className={styles.label}>{item.Name}</dt>
                <dd className={styles.description}>{item.Values?.join(', ').replace('True', 'Yes')}</dd>
              </div>
            )
          : null
      )}
    </dl>
  );
};

export default DescriptionList;
